module.exports = __webpack_public_path__ + "static/rtg-a3393c47759700863761078f9707a48e.jpg";